import { buildAbility } from './factory/ability.factory';
import { User, PermissionContext } from './types/ability.types';

const GUEST_USER: User = {
  id: '',
  email: '',
  roles: { organisations: [] },
};

/**
 * We initialize it with a 'guest' state (empty roles) so the app
 * doesn't crash on boot before the user is loaded.
 */
export const ability = buildAbility(GUEST_USER, {
  activeOrgId: '',
});

/**
 * This function is the only way to change the rules in the singleton.
 */
export function updateAbility(user: User | null, context: PermissionContext) {
  // If user logs out, we pass an empty object to clear permissions
  const nextAbility = buildAbility(user ?? GUEST_USER, context);

  ability.update(nextAbility.rules);
}
